import React, {FC} from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
} from "@chakra-ui/react";
import ShowOrderModal from "../Modal/ShowOrderModal";
import {Order, OrderTypes} from "../../shared/entities/Order/Order";

export type RoVinConflictRow = { orderId: number; namePo: string };

function orderStubForPopover(id: number): Order {
    return {
        id,
        tax: 0,
        shippingCost: 0,
        totalAmount: 0,
        sendCount: 0,
        printPressed: 0,
        shippingStatus: 0,
        paymentStatus: OrderTypes.IN,
        shippingComment: null,
        paymentComment: null,
        createdAt: 0,
        poNumber: null,
        tbd: false,
        namePo: null,
        confirmNumber: null,
        products: [],
        billingAddressId: 0,
        shippingAddressId: 0,
        user: null,
        dealership: null,
        paymentType: null,
        isDeleted: false,
        stripeTransactionId: null,
    };
}

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onContinue: () => void;
    conflicts: string[];
    conflictOrderIds: number[];
    conflictRows: RoVinConflictRow[];
};

export const RoVinConflictModal: FC<Props> = ({
    isOpen,
    onClose,
    onContinue,
    conflicts,
    conflictOrderIds,
    conflictRows,
}) => {
    const rows =
        conflictRows.length > 0
            ? conflictRows
            : conflictOrderIds.map((oid) => ({orderId: oid, namePo: ""}));

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Duplicate VIN in recent orders</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Text mb={3}>
                        This dealership has orders in the last 7 days whose RO field matches this VIN (by the last 8
                        characters). Do you want to continue checkout?
                    </Text>
                    {conflicts.length > 0 && (
                        <Text fontSize="sm" color="gray.600" mb={3}>
                            Matching VINs: {conflicts.join(", ")}
                        </Text>
                    )}
                    <Text fontWeight="semibold" mb={2}>Matching orders</Text>
                    <Table size="sm" variant="simple" mb={1}>
                        <Thead>
                            <Tr>
                                <Th>Order ID</Th>
                                <Th>RO</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {rows.map((row) => (
                                <Tr key={row.orderId}>
                                    <Td verticalAlign="middle">
                                        <ShowOrderModal order={orderStubForPopover(row.orderId)} openTrigger="click"/>
                                    </Td>
                                    <Td wordBreak="break-word" maxW="280px">
                                        {row.namePo || "—"}
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button variant="ghost" onClick={onClose}>Cancel</Button>
                    <Button colorScheme="blue" onClick={onContinue}>Continue</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
